export default __webpack_public_path__ + "locales/hy-AM/RoomLogoCover.json?hash=87e650738a818fbbc40b4a1a65b832ee";